var AttendeeCaptureEditModal = (function($, window, document, Attendee) {

    var controls = {};
    var _attendeeModel;
    var _modalCallbacks = $.Callbacks('unique');
    var _scrollPos;
    var ATTENDEE_CAPTURE_PATH = '/user/attendee_capture';
    // This is how checkout.js handles getting the base URL
    // If you don't determine the base URL this way, it's possible that
    // an environment will by default use the wrong base URL
    var ATTENDEE_CAPTURE_URL = window.labelRoot ? window.labelRoot + ATTENDEE_CAPTURE_PATH : ATTENDEE_CAPTURE_PATH;

    var bindControls = function() {
        var obj = {};
        
        obj.acModal = $('#attendee-capture-edit-modal');
        obj.acForm = $('#ac-form');
        obj.closeButton = $('#attendee-capture-edit-modal .close-ac');
        obj.formInputs = $('#ac-form input');
        obj.acLinks = $('[data-ac-item-id]');
        obj.errorSpan = $('#ac-error');
        obj.firstNameInput = $('#ac-form [name="firstName"]');
        obj.lastNameInput = $('#ac-form [name="lastName"]');
        obj.dayInput = $('#ac-form [name="dobDay"]');
        obj.monthInput = $('#ac-form [name="dobMonth"]');
        obj.yearInput = $('#ac-form [name="dobYear"]');
        obj.phoneInput = $('#ac-form [name="phoneNumber"]');
        obj.emailInput = $('#ac-form [name="email"]');
        obj.submitButton = $('#ac-form .submit');

        return obj;
    };

    var bindFunctions = function() {
        controls.closeButton.on('click', function() {
            resetModal();
        });

        submitHandler();
    };

    // Add class(s) to stop the body from scrolling
    // depending on the width of the document
    var disableBodyScroll = function() {
        if ($(window).width() < 768) {
            // Remember scroll position
            _scrollPos = $(document).scrollTop();
            $('html').addClass('mobile-safari-modal-open');
            $('body').addClass('mobile-safari-modal-open');
        } else {
            // Disable <body> scrolling
            $('body').addClass('modal-open-bootstrap');
        }
    };

    // Remove the disable body scroll class(s)
    var enableBodyScroll = function() {
        if ($(window).width() < 768) {
            $('html').removeClass('mobile-safari-modal-open');
            $('body').removeClass('mobile-safari-modal-open');
            // The disable scrolling classes need to be removed before
            // scrolling back to the saved position
            $(document).scrollTop(_scrollPos);
        } else {
            $('body').removeClass('modal-open-bootstrap');
        }
    };

    var showModal = function() {
        disableBodyScroll();
        controls.acModal.removeClass('hidden');
    };

    var hideModal = function() {
        enableBodyScroll();
        controls.acModal.addClass('hidden');
    };

    function populateFormInputs(model) {
        if ($.isEmptyObject(model)) {
            return;
        }

        controls.firstNameInput.val(model.getField('firstName'));
        controls.lastNameInput.val(model.getField('lastName'));
        controls.emailInput.val(model.getField('email'));
        controls.phoneInput.val(model.getField('phoneNumber'));
        controls.dayInput.val(model.getField('dobDay'));
        controls.monthInput.val(model.getField('dobMonth'));
        controls.yearInput.val(model.getField('dobYear'));
    }

    function resetModal() {
        $('#ac-form input.invalid').removeClass('invalid');
        clearErrorMessage();
        // Set the model variable to undefined
        _attendeeModel = undefined;
        // Reset form and hide the modal
        controls.acForm[0].reset();
        hideModal();
    }

    var submitHandler = function() {
        // Submitting form
        controls.acForm.submit(function(event) {
            event.preventDefault();

            var errs = getFormErrors();

            if (errs.length > 0) {
                configureErrors(errs);
                return;
            }

            // Change the submit button text to show the user
            // that something is happening
            submitBtnSavingState();

            var data = $(this).serializeArray();

            // Add the Seat Reserve ID (Item ID) to the payload
            var itemId = _attendeeModel.getItemId();
            data.push({name: 'seatReserveId', value: itemId});
            data.push({name: 'csrf_token', value: FG.Utils.getToken()});
            $.ajax({
                type: 'POST',
                url: ATTENDEE_CAPTURE_URL,
                data: $.param(data)
            })
            .then(successHandler, failHandler)
            .always(function() {
                submitBtnDefaultState();
            });

        });
    };

    var submitBtnSavingState = function() {
        controls.submitButton.text('Saving...');
        controls.submitButton.attr('disabled', 'disabled');
    };

    var submitBtnDefaultState = function() {
        controls.submitButton.text('Submit');
        controls.submitButton.removeAttr('disabled');
    };
    
    function successHandler(response) {
        if (!response.error) {
            // Update the current model attached to the Modal
            _attendeeModel.setData(response.data);
            _modalCallbacks.fire(_attendeeModel);
            resetModal();
        }
    }
    
    function failHandler(response) {
        var metadata = {
            seatReserveId: _attendeeModel.getItemId(),
            response: response
        };

        // Displaying a generic error message
        showErrorMessage('There was a problem saving your information. Please try again.');
    }
    
    function configureErrors(errs) {
        controls.formInputs.each(function() {
            var $input = $(this);
            
            var formattedName = $input.attr('data-formatted-name');
            var shouldHaveError = $.inArray(formattedName, errs) >= 0 ? true : false;

            if (shouldHaveError) {
                if (!$input.hasClass('invalid')) {
                    $input.addClass('invalid');
                }
            } else {
                if ($input.hasClass('invalid')) {
                    $input.removeClass('invalid');
                }
            }
        });

        var message = 'There\'s something wrong with your information. Please double check your ' + errs.join(', ') + '.';
        showErrorMessage(message);
    }
    
    function showErrorMessage(message) {            
        if (controls.errorSpan.length) {
            controls.errorSpan.text(message);
        }
    }
    
    function clearErrorMessage() {
        if (controls.errorSpan.length) {
            controls.errorSpan.text('');
        }
    }
    
    var validator = {
        isNameValid: function(text) {
            return /^[^\s].*$/.test(text);
        },
        isEmpty: function(value) {
            return value.trim().length === 0
        },
        isEmailValid: function(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        isPhoneValid: function(phone) {
            return /^[\+\-\d\s]+$/.test(phone);
        },
        isDayValid: function(day) {
            var dayNum = parseInt(day, 10);
            return dayNum >= 1 && dayNum <= 31;
        },
        isMonthValid: function(month) {
            var monthNum = parseInt(month, 10);
            return monthNum >= 1 && monthNum <= 12;
        },
        isYearValid: function(year) {
            var yearNum = parseInt(year, 10);
            return yearNum >= 1900 && yearNum <= 2024;
        }
    };
    
    function getFormErrors() {
        var errs = [];

        var addErr = function(value) {
            if (errs.indexOf(value) === -1) {
                errs.push(value)
            }
        };

        // Check for empty inputs
        controls.formInputs.each(function() {
            var $input = $(this);
            if (validator.isEmpty($input.val())) {
                errs.push($input.attr('data-formatted-name'));
            } 
        });

        if (!validator.isNameValid(controls.firstNameInput.val())) {
            var val = controls.firstNameInput.attr('data-formatted-name');
            addErr(val);
        }

        if (!validator.isNameValid(controls.lastNameInput.val())) {
            var val = controls.lastNameInput.attr('data-formatted-name');
            addErr(val);
        }

        if (!validator.isDayValid(controls.dayInput.val())) {
            var val = controls.dayInput.attr('data-formatted-name');
            addErr(val);
        }

        if (!validator.isMonthValid(controls.monthInput.val())) {
            var val = controls.monthInput.attr('data-formatted-name');
            addErr(val);
        }

        if (!validator.isYearValid(controls.yearInput.val())) {
            var val = controls.yearInput.attr('data-formatted-name');
            addErr(val);
        }
        
        if (!validator.isPhoneValid(controls.phoneInput.val())) {
            var val = controls.phoneInput.attr('data-formatted-name');
            addErr(val);
        }

        if (!validator.isEmailValid(controls.emailInput.val())) {
            var val = controls.emailInput.attr('data-formatted-name');
            addErr(val);
        }

        return errs;
    }

    var setData = function(attendeeModel) {
        _attendeeModel = attendeeModel;

        populateFormInputs(_attendeeModel);
    };

    var init = function(callback) {
        _modalCallbacks.add(callback);
        controls = bindControls();
        bindFunctions();
    };

    return {
        init: init,
        showModal: showModal,
        setData: setData
    };

}(window.jQuery, window, document, Attendee));
